export default {
  ON_BOARDING_VERIFY_NIP_REPOSITORY: Symbol.for('ON_BOARDING_VERIFY_NIP_REPOSITORY'),
  VERIFY_ON_BOARDING_NIP_COMMAND: Symbol.for('VERIFY_ON_BOARDING_NIP_COMMAND'),
};
